import React, { ReactNode } from "react";
import { addAreaValues } from "@helpers";
import { MiniChart } from "./MiniChart";

export type Props = {
  data: { date: any; value: number }[];
  icon: ReactNode;
  title: string;
  subtitle?: string;
  headline: string;
  percent?: number;
  percentPrefix?: string;
  onClick?: () => void;
  height?: string;
};

export const MiniCardChart = ({ data, onClick, height, ...rest }: Props) => {
  const dataWitArea = addAreaValues(data, "value", 0.7);
  return (
    <MiniChart onClick={onClick} data={dataWitArea} height={height} {...rest} />
  );
};
